"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { HelpCircle } from "lucide-react";
import { Input } from "@heroui/input";
import { Tooltip } from "@heroui/tooltip";
import { useMediaQuery } from "usehooks-ts";

export default function Search({ domain }) {
  const [inputValue, setInputValue] = React.useState("");
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width: 640px)");

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    router.push(`/${domain}?search=${e.target.value}`);
  };

  const clearInput = () => {
    setInputValue("");
    router.push(`/${domain}`);
  };

  return (
    <div className="relative flex w-full flex-col items-start space-y-2">
      <Input
        isClearable
        type="search"
        placeholder="Filter by something specific..."
        value={inputValue}
        onChange={handleInputChange}
        onClear={clearInput}
      />
      {!isMobile && (
        <Tooltip
          content={
            <span className="text-sm opacity-75">
              Use common search terms like{" "}
              <code className="inline-flex items-center rounded bg-foreground-200 px-2 py-1 font-mono text-xs font-medium">
                {`${
                  domain === "thoughts" ? " tag:tagname" : "url:example.com"
                }`}
              </code>
              , or{" "}
              <code className="inline-flex items-center rounded bg-foreground-200 px-2 py-1 font-mono text-xs font-medium">
                -phrase
              </code>{" "}
              to exclude results.
            </span>
          }
        >
          <HelpCircle className="absolute right-3 top-1 size-4 text-foreground" />
        </Tooltip>
      )}
    </div>
  );
}
